import { render, staticRenderFns } from "./tabOverview.vue?vue&type=template&id=5b53a1e3&"
import script from "./tabOverview.vue?vue&type=script&lang=js&"
export * from "./tabOverview.vue?vue&type=script&lang=js&"
import style0 from "./tabOverview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports